import type { QueryClient, QueryKey } from '@tanstack/react-query';
import {
  getListSitesQueryKey, getListBuildingsQueryKey, getListFloorsQueryKey, getListZonesQueryKey,
  getListSpacesQueryKey, getListBookingsQueryKey, getSearchAvailabilityQueryKey,
  getGetDashboardStatsQueryKey, getGetDashboardTimeseriesQueryKey,
  getGetUtilisationReportQueryKey, getGetNoShowReportQueryKey, getGetPeakReportQueryKey,
  getGetUnderutilisedReportQueryKey, getGetIntentVsActualReportQueryKey,
  getGetSiteQueryKey, getGetBuildingQueryKey, getGetFloorQueryKey, getGetZoneQueryKey,
  getGetSpaceQueryKey, getGetFloorTwinStatusQueryKey, getListFloorBookingsQueryKey,
  getGetInventoryLifecycleQueryKey, getListInventoryLifecycleHistoryQueryKey,
  getGetBookingQueryKey, getListBookingHistoryQueryKey
} from '@cdf/api-client-react';

const marker = '__inventory_lifecycle__';
function matchesTemplate(key: QueryKey, template: QueryKey): boolean {
  const route = template[0];
  if (typeof route !== 'string' || typeof key[0] !== 'string') return false;
  const escaped = route.split(marker).map(part => part.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  return new RegExp('^' + escaped.join('[^/]+') + '$').test(key[0]);
}

/** Generated route keys cover every filter variant and every descendant detail/map cache. */
export async function invalidateInventoryLifecycle(client: QueryClient, options?: { throwOnError?: boolean }): Promise<void> {
  const collections = [getListSitesQueryKey(), getListBuildingsQueryKey(), getListFloorsQueryKey(),
    getListZonesQueryKey(), getListSpacesQueryKey(), getListBookingsQueryKey(),
    getSearchAvailabilityQueryKey(), getGetDashboardStatsQueryKey(), getGetDashboardTimeseriesQueryKey(),
    getGetUtilisationReportQueryKey(), getGetNoShowReportQueryKey(), getGetPeakReportQueryKey(),
    getGetUnderutilisedReportQueryKey(), getGetIntentVsActualReportQueryKey()];
  const details = [getGetSiteQueryKey(marker), getGetBuildingQueryKey(marker), getGetFloorQueryKey(marker),
    getGetZoneQueryKey(marker), getGetSpaceQueryKey(marker), getGetFloorTwinStatusQueryKey(marker),
    getListFloorBookingsQueryKey(marker), getGetBookingQueryKey(marker), getListBookingHistoryQueryKey(marker),
    ...(['site', 'building', 'floor', 'zone', 'space'] as const).flatMap(level => [
      getGetInventoryLifecycleQueryKey(level, marker), getListInventoryLifecycleHistoryQueryKey(level, marker)])];
  await Promise.all([
    ...collections.map(queryKey => client.invalidateQueries({ queryKey: queryKey.slice(0, 1) }, options)),
    client.invalidateQueries({ predicate: query => details.some(key => matchesTemplate(query.queryKey, key)) }, options),
    client.invalidateQueries({ queryKey: ['upcoming-day-hierarchy'] }, options)
  ]);
}
